import React, { useState } from 'react';
import {
  Box,
  Container,
  Paper,
  Typography,
  CircularProgress
} from '@mui/material';
import InvoiceList from './InvoiceList';
import InvoiceForm from './InvoiceForm';
import InvoiceDetail from './InvoiceDetail';
import InvoiceService from '../../services/invoice.service';

const Invoice = () => {
  const [currentView, setCurrentView] = useState('list'); // 'list', 'form', 'detail'
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [editingInvoice, setEditingInvoice] = useState(null);

  const handleCreateInvoice = () => {
    setEditingInvoice(null);
    setCurrentView('form');
  };

  const handleEditInvoice = (invoice) => {
    // Prevent editing if invoice is certified
    if (invoice.fel_status === 'certificado' && invoice.fel_uuid) {
      alert('Cannot edit a certified invoice. Please cancel the invoice first if you need to make changes.');
      return;
    }
    setEditingInvoice(invoice);
    setCurrentView('form');
  };

  const handleViewInvoice = async (invoice) => {
    try {
      // Fetch full invoice details
      const response = await InvoiceService.getInvoice(invoice.id);
      if (response.data.success) {
        // The API returns the invoice directly with idetails loaded
        const invoiceData = response.data.data;
        setSelectedInvoice(invoiceData);
        setCurrentView('detail');
      }
    } catch (error) {
      console.error('Error loading invoice details:', error);
    }
  };

  const handleBackToList = () => {
    setCurrentView('list');
    setSelectedInvoice(null);
    setEditingInvoice(null);
  };

  const handleSaveInvoice = () => {
    setCurrentView('list');
    setEditingInvoice(null);
  };

  const renderCurrentView = () => {
    switch (currentView) {
      case 'list':
        return (
          <InvoiceList
            onEdit={handleEditInvoice}
            onView={handleViewInvoice}
            onCreate={handleCreateInvoice}
          />
        );
      case 'form':
        return (
          <InvoiceForm
            invoice={editingInvoice}
            onSave={handleSaveInvoice}
            onCancel={handleBackToList}
          />
        );
      case 'detail':
        return (
          <InvoiceDetail
            invoice={selectedInvoice}
            onEdit={() => handleEditInvoice(selectedInvoice)}
            onBack={handleBackToList}
          />
        );
      default:
        return null;
    }
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
        py: 3
      }}
    >
      <Container maxWidth="xl">
        {renderCurrentView()}
      </Container>
    </Box>
  );
};

export default Invoice;
